import { IntegrationServiceId, type WorkflowSupportedIntegration } from '../../../../../../common/integrations'
import { type IntegrationWorkflowAdapter } from './integrationWorkflow'
import { redtailWorkflowAdapter } from './redtail/redtailWorkflowAdapter'
import { wealthboxWorkflowAdapter } from './wealthbox/wealthboxWorkflowAdapter'

const INTEGRATION_WORKFLOW_ADAPTERS = {
  [IntegrationServiceId.WEALTHBOX]: wealthboxWorkflowAdapter,
  [IntegrationServiceId.REDTAIL]: redtailWorkflowAdapter,
} satisfies Record<WorkflowSupportedIntegration, IntegrationWorkflowAdapter<never>>

export const getIntegrationWorkflowAdapter = (serviceId: WorkflowSupportedIntegration): IntegrationWorkflowAdapter<never> =>
  INTEGRATION_WORKFLOW_ADAPTERS[serviceId]
